import { render, staticRenderFns } from "./Declare.vue?vue&type=template&id=8192fb9e&scoped=true"
import script from "./Declare.vue?vue&type=script&lang=js"
export * from "./Declare.vue?vue&type=script&lang=js"
import style0 from "./Declare.vue?vue&type=style&index=0&id=8192fb9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8192fb9e",
  null
  
)

export default component.exports